/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
export const JsonPatchOperationType = core.serialization.enum_(["add", "remove", "replace", "move", "copy", "test"]);
